'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
function _interopDefault$1(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}
var axios = _interopDefault$1(require('axios'));
var driscollsReactUtilities = require('driscolls-react-utilities');
function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}
createCommonjsModule(function (module) {
  /**
   * Copyright (c) 2014-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  !function (global) {
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var undefined$1; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    var runtime = global.regeneratorRuntime;
    if (runtime) {
      {
        // If regeneratorRuntime is defined globally and we're in a module,
        // make the exports object identical to regeneratorRuntime.
        module.exports = runtime;
      }
      // Don't bother evaluating the rest of this file if the runtime was
      // already defined globally.
      return;
    }

    // Define the runtime globally (as expected by generated code) as either
    // module.exports (if we're in a module) or a new, empty object.
    runtime = global.regeneratorRuntime = module.exports;
    function wrap(innerFn, outerFn, self, tryLocsList) {
      // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
      var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
      var generator = Object.create(protoGenerator.prototype);
      var context = new Context(tryLocsList || []);

      // The ._invoke method unifies the implementations of the .next,
      // .throw, and .return methods.
      generator._invoke = makeInvokeMethod(innerFn, self, context);
      return generator;
    }
    runtime.wrap = wrap;

    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
      try {
        return {
          type: "normal",
          arg: fn.call(obj, arg)
        };
      } catch (err) {
        return {
          type: "throw",
          arg: err
        };
      }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";

    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};

    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}

    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    IteratorPrototype[iteratorSymbol] = function () {
      return this;
    };
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
      // This environment has a native %IteratorPrototype%; use it instead
      // of the polyfill.
      IteratorPrototype = NativeIteratorPrototype;
    }
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
    GeneratorFunctionPrototype.constructor = GeneratorFunction;
    GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";

    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
      ["next", "throw", "return"].forEach(function (method) {
        prototype[method] = function (arg) {
          return this._invoke(method, arg);
        };
      });
    }
    runtime.isGeneratorFunction = function (genFun) {
      var ctor = typeof genFun === "function" && genFun.constructor;
      return ctor ? ctor === GeneratorFunction ||
      // For the native GeneratorFunction constructor, the best we can
      // do is to check its .name property.
      (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    runtime.mark = function (genFun) {
      if (Object.setPrototypeOf) {
        Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
      } else {
        genFun.__proto__ = GeneratorFunctionPrototype;
        if (!(toStringTagSymbol in genFun)) {
          genFun[toStringTagSymbol] = "GeneratorFunction";
        }
      }
      genFun.prototype = Object.create(Gp);
      return genFun;
    };

    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    runtime.awrap = function (arg) {
      return {
        __await: arg
      };
    };
    function AsyncIterator(generator) {
      function invoke(method, arg, resolve, reject) {
        var record = tryCatch(generator[method], generator, arg);
        if (record.type === "throw") {
          reject(record.arg);
        } else {
          var result = record.arg;
          var value = result.value;
          if (value && typeof value === "object" && hasOwn.call(value, "__await")) {
            return Promise.resolve(value.__await).then(function (value) {
              invoke("next", value, resolve, reject);
            }, function (err) {
              invoke("throw", err, resolve, reject);
            });
          }
          return Promise.resolve(value).then(function (unwrapped) {
            // When a yielded Promise is resolved, its final value becomes
            // the .value of the Promise<{value,done}> result for the
            // current iteration. If the Promise is rejected, however, the
            // result for this iteration will be rejected with the same
            // reason. Note that rejections of yielded Promises are not
            // thrown back into the generator function, as is the case
            // when an awaited Promise is rejected. This difference in
            // behavior between yield and await is important, because it
            // allows the consumer to decide what to do with the yielded
            // rejection (swallow it and continue, manually .throw it back
            // into the generator, abandon iteration, whatever). With
            // await, by contrast, there is no opportunity to examine the
            // rejection reason outside the generator function, so the
            // only option is to throw it from the await expression, and
            // let the generator function handle the exception.
            result.value = unwrapped;
            resolve(result);
          }, reject);
        }
      }
      var previousPromise;
      function enqueue(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new Promise(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(callInvokeWithMethodAndArg,
        // Avoid propagating failures to Promises returned by later
        // invocations of the iterator.
        callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }

      // Define the unified helper method that is used to implement .next,
      // .throw, and .return (see defineIteratorMethods).
      this._invoke = enqueue;
    }
    defineIteratorMethods(AsyncIterator.prototype);
    AsyncIterator.prototype[asyncIteratorSymbol] = function () {
      return this;
    };
    runtime.AsyncIterator = AsyncIterator;

    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    runtime.async = function (innerFn, outerFn, self, tryLocsList) {
      var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList));
      return runtime.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function (result) {
        return result.done ? result.value : iter.next();
      });
    };
    function makeInvokeMethod(innerFn, self, context) {
      var state = GenStateSuspendedStart;
      return function invoke(method, arg) {
        if (state === GenStateExecuting) {
          throw new Error("Generator is already running");
        }
        if (state === GenStateCompleted) {
          if (method === "throw") {
            throw arg;
          }

          // Be forgiving, per 25.3.3.3.3 of the spec:
          // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
          return doneResult();
        }
        context.method = method;
        context.arg = arg;
        while (true) {
          var delegate = context.delegate;
          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);
            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }
          if (context.method === "next") {
            // Setting context._sent for legacy support of Babel's
            // function.sent implementation.
            context.sent = context._sent = context.arg;
          } else if (context.method === "throw") {
            if (state === GenStateSuspendedStart) {
              state = GenStateCompleted;
              throw context.arg;
            }
            context.dispatchException(context.arg);
          } else if (context.method === "return") {
            context.abrupt("return", context.arg);
          }
          state = GenStateExecuting;
          var record = tryCatch(innerFn, self, context);
          if (record.type === "normal") {
            // If an exception is thrown from innerFn, we leave state ===
            // GenStateExecuting and loop back for another invocation.
            state = context.done ? GenStateCompleted : GenStateSuspendedYield;
            if (record.arg === ContinueSentinel) {
              continue;
            }
            return {
              value: record.arg,
              done: context.done
            };
          } else if (record.type === "throw") {
            state = GenStateCompleted;
            // Dispatch the exception by looping back around to the
            // context.dispatchException(context.arg) call above.
            context.method = "throw";
            context.arg = record.arg;
          }
        }
      };
    }

    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
      var method = delegate.iterator[context.method];
      if (method === undefined$1) {
        // A .throw or .return when the delegate iterator has no .throw
        // method always terminates the yield* loop.
        context.delegate = null;
        if (context.method === "throw") {
          if (delegate.iterator.return) {
            // If the delegate iterator has a return method, give it a
            // chance to clean up.
            context.method = "return";
            context.arg = undefined$1;
            maybeInvokeDelegate(delegate, context);
            if (context.method === "throw") {
              // If maybeInvokeDelegate(context) changed context.method from
              // "return" to "throw", let that override the TypeError below.
              return ContinueSentinel;
            }
          }
          context.method = "throw";
          context.arg = new TypeError("The iterator does not provide a 'throw' method");
        }
        return ContinueSentinel;
      }
      var record = tryCatch(method, delegate.iterator, context.arg);
      if (record.type === "throw") {
        context.method = "throw";
        context.arg = record.arg;
        context.delegate = null;
        return ContinueSentinel;
      }
      var info = record.arg;
      if (!info) {
        context.method = "throw";
        context.arg = new TypeError("iterator result is not an object");
        context.delegate = null;
        return ContinueSentinel;
      }
      if (info.done) {
        // Assign the result of the finished delegate to the temporary
        // variable specified by delegate.resultName (see delegateYield).
        context[delegate.resultName] = info.value;

        // Resume execution at the desired location (see delegateYield).
        context.next = delegate.nextLoc;

        // If context.method was "throw" but the delegate handled the
        // exception, let the outer generator proceed normally. If
        // context.method was "next", forget context.arg since it has been
        // "consumed" by the delegate iterator. If context.method was
        // "return", allow the original .return call to continue in the
        // outer generator.
        if (context.method !== "return") {
          context.method = "next";
          context.arg = undefined$1;
        }
      } else {
        // Re-yield the result returned by the delegate method.
        return info;
      }

      // The delegate iterator is finished, so forget it and continue with
      // the outer generator.
      context.delegate = null;
      return ContinueSentinel;
    }

    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    Gp[toStringTagSymbol] = "Generator";

    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    Gp[iteratorSymbol] = function () {
      return this;
    };
    Gp.toString = function () {
      return "[object Generator]";
    };
    function pushTryEntry(locs) {
      var entry = {
        tryLoc: locs[0]
      };
      if (1 in locs) {
        entry.catchLoc = locs[1];
      }
      if (2 in locs) {
        entry.finallyLoc = locs[2];
        entry.afterLoc = locs[3];
      }
      this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
      var record = entry.completion || {};
      record.type = "normal";
      delete record.arg;
      entry.completion = record;
    }
    function Context(tryLocsList) {
      // The root entry object (effectively a try statement without a catch
      // or a finally block) gives us a place to store values thrown from
      // locations where there is no enclosing try statement.
      this.tryEntries = [{
        tryLoc: "root"
      }];
      tryLocsList.forEach(pushTryEntry, this);
      this.reset(true);
    }
    runtime.keys = function (object) {
      var keys = [];
      for (var key in object) {
        keys.push(key);
      }
      keys.reverse();

      // Rather than returning an object with a next method, we keep
      // things simple and return the next function itself.
      return function next() {
        while (keys.length) {
          var key = keys.pop();
          if (key in object) {
            next.value = key;
            next.done = false;
            return next;
          }
        }

        // To avoid creating an additional object, we just hang the .value
        // and .done properties off the next function object itself. This
        // also ensures that the minifier will not anonymize the function.
        next.done = true;
        return next;
      };
    };
    function values(iterable) {
      if (iterable) {
        var iteratorMethod = iterable[iteratorSymbol];
        if (iteratorMethod) {
          return iteratorMethod.call(iterable);
        }
        if (typeof iterable.next === "function") {
          return iterable;
        }
        if (!isNaN(iterable.length)) {
          var i = -1,
            next = function next() {
              while (++i < iterable.length) {
                if (hasOwn.call(iterable, i)) {
                  next.value = iterable[i];
                  next.done = false;
                  return next;
                }
              }
              next.value = undefined$1;
              next.done = true;
              return next;
            };
          return next.next = next;
        }
      }

      // Return an iterator with no values.
      return {
        next: doneResult
      };
    }
    runtime.values = values;
    function doneResult() {
      return {
        value: undefined$1,
        done: true
      };
    }
    Context.prototype = {
      constructor: Context,
      reset: function (skipTempReset) {
        this.prev = 0;
        this.next = 0;
        // Resetting context._sent for legacy support of Babel's
        // function.sent implementation.
        this.sent = this._sent = undefined$1;
        this.done = false;
        this.delegate = null;
        this.method = "next";
        this.arg = undefined$1;
        this.tryEntries.forEach(resetTryEntry);
        if (!skipTempReset) {
          for (var name in this) {
            // Not sure about the optimal order of these conditions:
            if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
              this[name] = undefined$1;
            }
          }
        }
      },
      stop: function () {
        this.done = true;
        var rootEntry = this.tryEntries[0];
        var rootRecord = rootEntry.completion;
        if (rootRecord.type === "throw") {
          throw rootRecord.arg;
        }
        return this.rval;
      },
      dispatchException: function (exception) {
        if (this.done) {
          throw exception;
        }
        var context = this;
        function handle(loc, caught) {
          record.type = "throw";
          record.arg = exception;
          context.next = loc;
          if (caught) {
            // If the dispatched exception was caught by a catch block,
            // then let that catch block handle the exception normally.
            context.method = "next";
            context.arg = undefined$1;
          }
          return !!caught;
        }
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          var record = entry.completion;
          if (entry.tryLoc === "root") {
            // Exception thrown outside of any try block that could handle
            // it, so set the completion value of the entire function to
            // throw the exception.
            return handle("end");
          }
          if (entry.tryLoc <= this.prev) {
            var hasCatch = hasOwn.call(entry, "catchLoc");
            var hasFinally = hasOwn.call(entry, "finallyLoc");
            if (hasCatch && hasFinally) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              } else if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else if (hasCatch) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              }
            } else if (hasFinally) {
              if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else {
              throw new Error("try statement without catch or finally");
            }
          }
        }
      },
      abrupt: function (type, arg) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
            var finallyEntry = entry;
            break;
          }
        }
        if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
          // Ignore the finally entry if control is not jumping to a
          // location outside the try/catch block.
          finallyEntry = null;
        }
        var record = finallyEntry ? finallyEntry.completion : {};
        record.type = type;
        record.arg = arg;
        if (finallyEntry) {
          this.method = "next";
          this.next = finallyEntry.finallyLoc;
          return ContinueSentinel;
        }
        return this.complete(record);
      },
      complete: function (record, afterLoc) {
        if (record.type === "throw") {
          throw record.arg;
        }
        if (record.type === "break" || record.type === "continue") {
          this.next = record.arg;
        } else if (record.type === "return") {
          this.rval = this.arg = record.arg;
          this.method = "return";
          this.next = "end";
        } else if (record.type === "normal" && afterLoc) {
          this.next = afterLoc;
        }
        return ContinueSentinel;
      },
      finish: function (finallyLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.finallyLoc === finallyLoc) {
            this.complete(entry.completion, entry.afterLoc);
            resetTryEntry(entry);
            return ContinueSentinel;
          }
        }
      },
      "catch": function (tryLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.tryLoc === tryLoc) {
            var record = entry.completion;
            if (record.type === "throw") {
              var thrown = record.arg;
              resetTryEntry(entry);
            }
            return thrown;
          }
        }

        // The context.catch method must only be called with a location
        // argument that corresponds to a known catch block.
        throw new Error("illegal catch attempt");
      },
      delegateYield: function (iterable, resultName, nextLoc) {
        this.delegate = {
          iterator: values(iterable),
          resultName: resultName,
          nextLoc: nextLoc
        };
        if (this.method === "next") {
          // Deliberately forget the last sent value so that we don't
          // accidentally pass it on to the delegate.
          this.arg = undefined$1;
        }
        return ContinueSentinel;
      }
    };
  }(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  function () {
    return this;
  }() || Function("return this")());
});
var asyncToGenerator = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }
      return step("next");
    });
  };
};
var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
};
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var API_COOL_DOWN_IN_MILLISECONDS = 1000;
var API_DUPLICATE_CALLS_ALLOWED = 5;
var dataHandlers = {};
var requests = {};

//TODO: We should keep track of APIs that fail here and batch them up so we can send them when the APIs start working again.
//      Keep track in a cookie as well.
//var failedApiCalls = [];

var handleError = function handleError(error, showErrorDialogAction) {
  if (error.response) {
    if (error.response.status >= 500) {
      //Probably a condition was not met, print out the request object
      console.error('HTTP Status Indicated Server Failure (%i)\n%s', error.response.status, error.response.data);
      if (showErrorDialogAction) {
        showErrorDialogAction('Network Failure', "Server related issue, please try again in a little bit. If this keeps happening please contact Driscoll's IT.");
      }
    } else if (error.response.status >= 400) {
      //Probably a condition was not met, print out the request object
      console.error('HTTP Status Indicated Local Failure (%i)\n%s', error.response.status, error.response.data);
      if (showErrorDialogAction) {
        showErrorDialogAction('Network Failure', "Website related issue, please verify data and re-try the last action. If this keeps happening please contact Driscoll's IT.");
      }
    } else {
      //Maybe a data error, give details on where in code this occurred.
      console.error('Error Processing Data Returned (%i)\n%s', error.response.status, error.response.data);
      if (showErrorDialogAction) {
        showErrorDialogAction('Network Failure', "Unknown Error. If this keeps happening please contact Driscoll's IT.");
      }
    }
  } else {
    //Network error or CORS issue not sure what we can say much more than that.
    console.error('Network Error, could be CORS could be bad internet connection');
    if (showErrorDialogAction) {
      showErrorDialogAction('Network Error', "Network connection interrupted or an security policy has blocked this request. If this keeps happening please contact Driscoll's IT.");
    }
  }
};
var HandleLoadingApi = function HandleLoadingApi(promise, openLoadingScreenAction, closeLoadingScreenAction, showErrorDialogAction) {
  openLoadingScreenAction();
  promise.then(function () {
    closeLoadingScreenAction();
  }).catch(function (error) {
    closeLoadingScreenAction();
    handleError(error, showErrorDialogAction);
  });
  return promise;
};
var registerFunctions = function registerFunctions(key, data, handlers) {
  var handlerKey = Object.keys(handlers)[0];
  var keyLower = key.toLowerCase();
  var currentHandlers = dataHandlers[keyLower];
  if (currentHandlers) {
    if (currentHandlers.handlers[handlerKey]) {
      console.error('Function already registered.');
      return;
    } else {
      dataHandlers[keyLower].handlers = _extends({}, dataHandlers[keyLower].handlers, handlers);
      return;
    }
  }
  dataHandlers[keyLower] = {
    data: data,
    handlers: handlers
  };
};
var getExternalListName = function getExternalListName(mapping) {
  var returnValue = null;
  mapping.forEach(function (row) {
    if (row.IsArray) {
      returnValue = row.ExternalVariableName;
      return;
    }
  });
  return returnValue;
};
var updateFunctionData = function updateFunctionData(key, data) {
  var keyLower = key.toLowerCase();
  if (!dataHandlers[keyLower]) {
    console.error('Function not already registered.');
    return;
  }
  dataHandlers[keyLower] = {
    data: data,
    handlers: dataHandlers[keyLower].handlers
  };
};
var createHandler = function createHandler(method, handler) {
  var handlerObj = defineProperty({}, method, handler);
  return handlerObj;
};
var checkRegisteredFunctions = function checkRegisteredFunctions(key) {
  var keyLower = key.toLowerCase();
  if (dataHandlers[keyLower]) {
    return true;
  }
  return false;
};
var isEquivalent = function isEquivalent(a, b) {
  // Checks for undefined payloads, these
  // cause Object.getOwnPropertyNames() to fail
  if (a === undefined || b === undefined) {
    if (a === undefined && b === undefined) {
      return true;
    } else {
      return false;
    }
  }

  // Create arrays of property names
  var aProps = Object.getOwnPropertyNames(a);
  var bProps = Object.getOwnPropertyNames(b);

  // If number of properties is different,
  // objects are not equivalent
  if (aProps.length != bProps.length) {
    return false;
  }
  for (var i = 0; i < aProps.length; i++) {
    var propName = aProps[i];

    // If values of same property are not equal,
    // objects are not equivalent
    if (a[propName] !== b[propName]) {
      return false;
    }
  }

  // If we made it this far, objects
  // are considered equivalent
  return true;
};
var handleAPICall = function () {
  var _ref = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(key, token, url, method, requestObj, props, mapping, args, defaultRequestObj, headerObj) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', new Promise(function (resolve, reject) {
              var keyLower = key.toLowerCase();
              var time = new Date();
              var resetRedundancy = false;
              if (requests[url] && isEquivalent(requests[url].request, requestObj)) {
                if (time - requests[url].occurred <= API_COOL_DOWN_IN_MILLISECONDS && requests[url].occurrences >= API_DUPLICATE_CALLS_ALLOWED) {
                  console.groupCollapsed('API Redundancy Detected');
                  console.error('Found a duplicate API call');
                  console.error(url);
                  console.error(requestObj);
                  console.error('This error is likely caused by a bug, please report to a friendly developer');
                  console.groupEnd();
                  reject();
                  return;
                }
                resetRedundancy = true;
              }
              var occurrences = requests[url] && !resetRedundancy ? requests[url].occurrences + 1 : 1;
              requests[url] = {
                occurred: time,
                request: requestObj,
                occurrences: occurrences
              };
              props.showLoadingScreen(props.loadingMessage);
              if (checkRegisteredFunctions(keyLower)) {
                console.groupCollapsed('Fake API');
                console.log('Logging Fake Data usage, no cause for alarm');
                console.groupCollapsed(key);
                console.warn('%s with url: %s', key, url);
                console.log('Request Object: ', requestObj);
                console.groupEnd();
                console.groupEnd();
                if ((url || '').length > 0) {
                  console.group('Fake API');
                  console.error('We are not expecting to use fake data for %s as it has a url of %s', key, url);
                  console.groupEnd();
                }
                callFakeAPI(keyLower, url, requestObj, method, mapping, args).then(function (data) {
                  props.hideLoadingScreen();
                  resolve(data);
                  return;
                }).catch(function (error) {
                  props.hideLoadingScreen();
                  //TODO: Figure out if we want to show the error modal here or not, might want to have that configurable
                  reject(data);
                  throw error;
                });
              } else {
                var request = defaultRequestObj !== null ? _extends({}, defaultRequestObj, requestObj) : requestObj;
                callAPI(token, url, request, method, headerObj).then(function (data) {
                  props.hideLoadingScreen();
                  resolve(data);
                  return;
                }).catch(function (error) {
                  props.hideLoadingScreen();
                  if (error.response) {
                    if (error.response.status >= 400) {
                      var _data = {
                        data: error
                      };
                      reject(_data);
                    }
                  }
                  //TODO: Figure out if we want to show the error modal here or not, might want to have that configurable
                  throw error;
                });
              }
            }));
          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));
  return function handleAPICall(_x, _x2, _x3, _x4, _x5, _x6, _x7, _x8, _x9, _x10) {
    return _ref.apply(this, arguments);
  };
}();
var callAPI = function callAPI(token, url, requestObj, method, headerObj) {
  return axios({
    method: method,
    url: url,
    data: requestObj,
    headers: token ? _extends({
      Authorization: (token.length <= 100 ? 'Basic ' : 'Bearer ') + token
    }, headerObj) : headerObj ? headerObj : null
  });
};
var callFakeAPI = function () {
  var _ref2 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(name, url, requestObj, method, mapping, args) {
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', new Promise(function (resolve, reject) {
              var nameLower = name.toLowerCase();
              var handler = dataHandlers[nameLower];
              var data = handler.handlers[method](handler.data, requestObj, mapping, args);
              if (method === 'POST') {
                updateFunctionData(name, data);
              }
              resolve(data);
            }));
          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));
  return function callFakeAPI(_x11, _x12, _x13, _x14, _x15, _x16) {
    return _ref2.apply(this, arguments);
  };
}();
var filterToOne = function filterToOne(data, requestObj, mapping, args) {
  var filters = Object.entries(requestObj);
  var returnObj = {};
  var dataArray = [];
  // Check to see if payload is empty
  if (Object.entries(requestObj).length === 0 && requestObj.constructor === Object) {
    // Do we want to return empty obj or null?
    return returnObj;
  }
  mapping.forEach(function (map) {
    if (map.ExternalArrayVariableNameToCount.length > 0) {
      externalArrayVariableNameToCount = map.ExternalVariableName;
    }
    if (map.IsArray) {
      dataArray = data[map.ExternalVariableName];
      map.ExternalVariableName;
    }
  });
  dataArray.forEach(function (item) {
    var retValue = true;
    filters.forEach(function (filter) {
      if (filter[0] === 'BerryTypes' && item.BerryTypes !== undefined) {
        if (!checkObject(item.BerryTypes, filter[1])) {
          retValue = false;
        }
      } else if (item[filter[0]] !== filter[1]) {
        retValue = false;
        return;
      }
    });
    if (retValue) {
      returnObj = item;
      return;
    }
  });
  return returnObj;
};
var myFilter = function myFilter(data, requestObj, mapping, args) {
  var _babelHelpers$extends;
  var filters = Object.entries(requestObj);
  if (Object.entries(requestObj).length === 0 && requestObj.constructor === Object) {
    return data;
  }

  // Add ability to use multiple arrays
  var dataArray = [];
  var extVarName = '';
  var externalArrayVariableNameToCount = '';
  mapping.forEach(function (map) {
    if (map.ExternalArrayVariableNameToCount.length > 0) {
      externalArrayVariableNameToCount = map.ExternalVariableName;
    }
    if (map.IsArray) {
      dataArray = data[map.ExternalVariableName];
      extVarName = map.ExternalVariableName;
    }
  });
  var filteredData = dataArray.filter(function (item) {
    var retValue = true;
    filters.forEach(function (filter) {
      if (filter[0] === 'BerryTypes' && item.BerryTypes !== undefined) {
        if (!checkObject(item.BerryTypes, filter[1])) {
          retValue = false;
        }
      } else if (item[filter[0]] !== filter[1]) {
        retValue = false;
        return;
      }
    });
    return retValue;
  });
  var returnObj = _extends({}, data, (_babelHelpers$extends = {}, defineProperty(_babelHelpers$extends, extVarName, filteredData), defineProperty(_babelHelpers$extends, externalArrayVariableNameToCount || 'Count', filteredData.length), _babelHelpers$extends));
  return returnObj;
};
var noOp = function noOp(data, requestObj, mapping, args) {
  return data;
};

/**
 * Update a Single Item in a list of data.
 *
 * @param {Array}  data       The Data from the fake data that was provided in the mapping.
 * @param {Object} requestObj The Request Object sent to the API, but can be used with the fake data as well.
 * @param {Object} mapping    The mapping object that is passed in from the middleware to aide in additional mapping conversion if needed.
 * @param {Object} args       Requires Variable in object: MatchVariableName. This is the variable name for which to index on to find the correct item to update.
 */
var updateOne = function updateOne(data, requestObj, mapping, args) {
  var listName = getExternalListName(mapping);
  if (listName === null) {
    console.error('No list registered in data.');
    return;
  }
  var indexName = args.MatchVariableName || args.IndexVarName || '';
  var isAltered = false;
  if (indexName.length <= 0) {
    mapping.some(function (map) {
      if (map.IsIndex) {
        indexName = map.ExternalVariableName;
        return true;
      }
    });
  }
  if (indexName.length <= 0) {
    console.error('No MatchVariableName set in arguments passed in.');
    return;
  }
  var returnObj = _extends({}, data, defineProperty({}, listName, data[listName].map(function (row) {
    if (row[indexName] === requestObj[indexName]) {
      isAltered = true;
      return _extends({}, row, requestObj);
    }
    return row;
  })));
  if (!isAltered) {
    returnObj[listName].push(_extends({}, requestObj));
  }
  return returnObj;
};
var checkObject = function checkObject(item, filter) {
  var found = false;
  for (var i = 0; i < item.length; i++) {
    if (item[i].value === filter) {
      found = true;
      break;
    }
  }
  return found;
};
var ApiUtilities = {
  HandleApiError: handleError,
  HandleLoadingApi: HandleLoadingApi,
  RegisterFunctions: registerFunctions,
  CheckRegisteredFunctions: checkRegisteredFunctions,
  CreateHandler: createHandler,
  HandleAPICall: handleAPICall,
  Filter: myFilter,
  FilterToOne: filterToOne,
  NoOp: noOp,
  UpdateOne: updateOne
};
var InitialProps = {
  showLoadingScreen: function showLoadingScreen() {},
  hideLoadingScreen: function hideLoadingScreen() {},
  showErrorDialog: function showErrorDialog() {},
  overrideRequestMapping: false,
  overrideResponseMapping: false,
  loadingMessage: 'Loading'
};
var supportedMethods = ['GET', 'PUT', 'POST', 'DELETE', 'PATCH'];
var mappings = {};
var sortableMappingKeys = {};
var storedProps = InitialProps;
var overrideToken = '';
var defaultPayloadHandler = function defaultPayloadHandler() {};
var isDefaultPayloadLoaded = false;
var isDefaultPayloadSet = false;
var defaultPayload = {};
var checkMiddlewareMapping = function checkMiddlewareMapping(name, method) {
  var key = method.toLowerCase() + name.toLowerCase();
  return mappings[key];
};
var createMiddlewareMapping = function createMiddlewareMapping(localVariableName, externalVariableName, translateToLocalFunction, translateToExternalFunction, externalHandler) {
  return {
    LocalVariableName: localVariableName,
    ExternalVariableName: externalVariableName,
    TranslateToLocalFunction: translateToLocalFunction || function (data) {
      return data;
    },
    TranslateToExternalFunction: translateToExternalFunction || function (data) {
      return data;
    },
    ExternalHandler: externalHandler || null,
    IsArray: false,
    IsObject: false,
    ExternalArrayVariableNameToCount: '',
    IsIndex: false,
    IsSorting: false
  };
};
var createMiddlewareIndexMapping = function createMiddlewareIndexMapping(localVariableName, externalVariableName, translateToLocalFunction, translateToExternalFunction, externalHandler) {
  return {
    LocalVariableName: localVariableName,
    ExternalVariableName: externalVariableName,
    TranslateToLocalFunction: translateToLocalFunction || function (data) {
      return data;
    },
    TranslateToExternalFunction: translateToExternalFunction || function (data) {
      return data;
    },
    ExternalHandler: externalHandler || null,
    IsArray: false,
    IsObject: false,
    ExternalArrayVariableNameToCount: '',
    IsIndex: true,
    IsSorting: false
  };
};
var createMiddlewareSortMapping = function createMiddlewareSortMapping(localVariableName, externalVariableName, translateToLocalFunction, translateToExternalFunction, externalHandler) {
  return {
    LocalVariableName: localVariableName,
    ExternalVariableName: externalVariableName,
    TranslateToLocalFunction: translateToLocalFunction || function (data) {
      return data;
    },
    TranslateToExternalFunction: translateToExternalFunction || function (data) {
      return data;
    },
    ExternalHandler: externalHandler || null,
    IsArray: false,
    IsObject: false,
    ExternalArrayVariableNameToCount: '',
    IsIndex: false,
    IsSorting: true
  };
};
var createMiddlewareArrayMapping = function createMiddlewareArrayMapping(localVariableName, externalVariableName, translateToLocalFunction, translateToExternalFunction, externalHandler) {
  return {
    LocalVariableName: localVariableName,
    ExternalVariableName: externalVariableName || '',
    TranslateToLocalFunction: translateToLocalFunction || function (data) {
      return data;
    },
    TranslateToExternalFunction: translateToExternalFunction || function (data) {
      return data;
    },
    ExternalHandler: externalHandler || null,
    IsArray: true,
    IsObject: false,
    ExternalArrayVariableNameToCount: '',
    IsIndex: false,
    IsSorting: false
  };
};
var createMiddlewareArrayResultCountMapping = function createMiddlewareArrayResultCountMapping(localVariableName, externalVariableName, externalArrayVariableNameToCount, translateToLocalFunction, translateToExternalFunction, externalHandler) {
  return {
    LocalVariableName: localVariableName,
    ExternalVariableName: externalVariableName,
    TranslateToLocalFunction: translateToLocalFunction || function (data) {
      return data;
    },
    TranslateToExternalFunction: translateToExternalFunction || function (data) {
      return data;
    },
    ExternalHandler: externalHandler || null,
    IsArray: false,
    IsObject: false,
    ExternalArrayVariableNameToCount: externalArrayVariableNameToCount || '',
    IsIndex: false,
    IsSorting: false
  };
};
var createMiddlewareObjectMapping = function createMiddlewareObjectMapping(localVariableName, externalVariableName, translateToLocalFunction, translateToExternalFunction, externalHandler) {
  return {
    LocalVariableName: localVariableName,
    ExternalVariableName: externalVariableName,
    TranslateToLocalFunction: translateToLocalFunction || function (data) {
      return data;
    },
    TranslateToExternalFunction: translateToExternalFunction || function (data) {
      return data;
    },
    ExternalHandler: externalHandler || null,
    IsArray: false,
    IsObject: true,
    ExternalArrayVariableNameToCount: '',
    IsIndex: false,
    IsSorting: false
  };
};
var registerMiddlewareMapping = function registerMiddlewareMapping(name, method, mapping, allowSorting) {
  var key = method.toLowerCase() + name.toLowerCase();
  if (mappings[key]) {
    console.error('Middleware: Mapping already exists.');
    return;
  }
  mappings[key] = mapping;
  sortableMappingKeys[key] = allowSorting || false;
};
var setPropsObj = function setPropsObj(openLoadingScreenAction, closeLoadingScreenAction, showErrorDialogAction) {
  var useMappings = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var loadingMessage = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'Loading';
  storedProps = _extends({}, storedProps, {
    showLoadingScreen: openLoadingScreenAction,
    hideLoadingScreen: closeLoadingScreenAction,
    showErrorDialog: showErrorDialogAction,
    overrideRequestMapping: !useMappings,
    overrideResponseMapping: !useMappings,
    loadingMessage: loadingMessage
  });
  return storedProps;
};

//TODO: Make this recursive when it finds an array or object it should call itself with the found array or object
var processToLocal = function processToLocal(key, data, allowEmptyValues) {
  if (!mappings[key]) {
    console.error('Middleware: Mapping does not exist. Cannot proceed with API call.');
    throw new Error('no mapping exists');
  }

  //go through the mapping for each item
  var mapping = mappings[key];
  var returnObj = {};
  var arrayNameMaps = [];
  var objectNameMaps = [];
  data = data || [];
  mapping.forEach(function (map) {
    if (map.IsArray) {
      arrayNameMaps.push(map);
    }
  });
  mapping.forEach(function (map) {
    if (map.IsObject) {
      objectNameMaps.push(map);
    }
  });

  //Go through all arrays in data
  arrayNameMaps.forEach(function (arrayNameMap) {
    var array = (arrayNameMap.ExternalVariableName === '' ? data : data[arrayNameMap.ExternalVariableName]) || [];
    if (!Array.isArray(array)) {
      return;
    }
    if (!returnObj[arrayNameMap.LocalVariableName]) {
      returnObj[arrayNameMap.LocalVariableName] = [];
    }
    array.forEach(function (row) {
      var returnRow = {};
      mapping.forEach(function (map) {
        var externalData = null;
        //Find the external function to call to get the external data
        if (map.ExternalHandler) {
          externalData = map.ExternalHandler(row);
        } else {
          //If that doesn't exist get the data from the external variable name
          externalData = row[map.ExternalVariableName];
        }
        var localData = map.TranslateToLocalFunction ? map.TranslateToLocalFunction(externalData) : externalData;
        if (allowEmptyValues || localData || typeof localData === 'number' || typeof localData === 'boolean') {
          returnRow[map.LocalVariableName] = localData;
        }
      });
      returnObj[arrayNameMap.LocalVariableName].push(returnRow);
    });
  });

  //Go through all objects in data
  objectNameMaps.forEach(function (objNameMap) {
    var obj = data[objNameMap.ExternalVariableName] || {};
    var returnSecondaryObj = {};
    mapping.forEach(function (map) {
      var field = obj[map.ExternalVariableName];
      var externalData = null;

      //Find the external function to call to get the external data
      if (map.ExternalHandler) {
        externalData = map.ExternalHandler(field);
      } else {
        //If that doesn't exist get the data from the external variable name
        externalData = field;
      }
      var localData = map.TranslateToLocalFunction ? map.TranslateToLocalFunction(externalData) : externalData;
      if (localData || typeof localData === 'number') {
        returnSecondaryObj[map.LocalVariableName] = localData;
      }
    });
    if (!returnObj[objNameMap.LocalVariableName]) {
      returnObj[objNameMap.LocalVariableName] = {};
    }
    returnObj[objNameMap.LocalVariableName] = returnSecondaryObj;
  });

  //Go through all variables at root level in data
  mapping.forEach(function (map) {
    if (map.IsArray || map.IsObject) {
      return;
    }
    var externalData = null;

    //Find the external function to call to get the external data
    if (map.ExternalHandler) {
      externalData = map.ExternalHandler(data);
    } else {
      //If that doesn't exist get the data from the external variable name
      externalData = data[map.ExternalVariableName];
    }
    var localData = map.TranslateToLocalFunction ? map.TranslateToLocalFunction(externalData) : externalData;
    if (localData) {
      returnObj[map.LocalVariableName] = localData;
    }
  });
  return returnObj;
};
var processToExternal = function processToExternal(key, data) {
  if (!mappings[key]) {
    console.error('Middleware: Mapping does not exist. Cannot proceed with API call.');
    throw new Error('no mapping exists');
  }

  //go through the mapping for each item
  var mapping = mappings[key];
  var returnObj = {};
  var arrayNameMaps = [];
  data = data || [];
  mapping.forEach(function (map) {
    if (map.IsArray) {
      arrayNameMaps.push(map);
    }
    if (map.IsObject) ;
  });

  //Go through all arrays in data
  arrayNameMaps.forEach(function (arrayNameMap) {
    (data[arrayNameMap.LocalVariableName] || []).forEach(function (row) {
      var returnRow = {};
      mapping.forEach(function (map) {
        var localData = null;
        localData = row[map.LocalVariableName];
        var externalData = map.TranslateToExternalFunction ? map.TranslateToExternalFunction(localData) : localData;
        if (externalData) {
          returnRow[map.ExternalVariableName] = externalData;
        }
      });
      if (!returnObj[arrayNameMap.ExternalVariableName]) {
        returnObj[arrayNameMap.ExternalVariableName] = [];
      }
      returnObj[arrayNameMap.ExternalVariableName].push(returnRow);
    });
  });

  //Go through all variables at root level in data
  mapping.forEach(function (map) {
    if (map.IsArray) {
      return;
    }
    var localData = null;

    //Find the external function to call to get the external data
    if (map.LocalHandler) {
      localData = map.LocalHandler(data);
    } else {
      //If that doesn't exist get the data from the external variable name
      localData = data[map.LocalVariableName];
    }
    var externalData = map.TranslateToExternalFunction ? map.TranslateToExternalFunction(localData) : localData;
    if (externalData != null && (typeof externalData === 'boolean' || externalData)) {
      returnObj[map.ExternalVariableName] = externalData;
    }
  });
  return returnObj;
};

/**
 * Converts the Arguments data in each variable to the external equivalent
 *
 * @param {string} key
 * @param {Object} args
 */
var convertArgsToExternal = function convertArgsToExternal(key, args) {
  if (!mappings[key]) {
    console.error('Middleware: Mapping does not exist. Cannot proceed with API call.');
    throw new Error('no mapping exists');
  }
  var mapping = mappings[key];
  var returnObj = {};
  args = args || {};
  Object.entries(args).forEach(function (param) {
    var variableName = param[0];
    var variableData = param[1];
    var map = mapping.find(function (map) {
      return map.LocalVariableName === variableData;
    });
    returnObj[variableName] = !!map ? map.ExternalVariableName : variableData;
  });
  return returnObj;
};
var sendRawApiCall = function () {
  var _ref = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(token, url, method, requestObj, headerObj) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', sendApiCall('', token, url, method || 'GET', requestObj, {
              overrideRequestMapping: true,
              overrideResponseMapping: true
            }, {}, 0, headerObj));
          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));
  return function sendRawApiCall(_x3, _x4, _x5, _x6, _x7) {
    return _ref.apply(this, arguments);
  };
}();
var sendRawApiCallNoDialogs = function () {
  var _ref2 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(token, url, method, requestObj, headerObj) {
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', sendApiCall('', token, url, method || 'GET', requestObj, {
              showLoadingScreen: function showLoadingScreen() {},
              hideLoadingScreen: function hideLoadingScreen() {},
              showErrorDialog: function showErrorDialog() {},
              overrideRequestMapping: true,
              overrideResponseMapping: true
            }, {}, 0, headerObj));
          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));
  return function sendRawApiCallNoDialogs(_x8, _x9, _x10, _x11, _x12) {
    return _ref2.apply(this, arguments);
  };
}();
var sendApiCall = function () {
  var _ref3 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(name, token, url, method, requestObj, props, args) {
    var cacheLifespanInMinutes = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 0;
    var headerObj = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : null;
    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt('return', new Promise(function () {
              var _ref4 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(resolve, reject) {
                var _this = this;
                var key, cacheKey, combinedProps, data, newPayload, request, convertedArgs, result;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                  while (1) {
                    switch (_context5.prev = _context5.next) {
                      case 0:
                        if (!method) {
                          method = 'GET';
                        }
                        if (!supportedMethods.includes(method.toUpperCase())) {
                          console.error('Middleware: Method ' + method + ' is not supported by the OneRing. Forge a new method to use it.');
                          console.log('Middleware: Method ' + method + ' is not supported by the OneRing. Forge a new method to use it.');
                        }
                        key = method.toLowerCase() + name.toLowerCase();
                        cacheKey = '';
                        combinedProps = _extends({}, storedProps, props || {});
                        if (!(!combinedProps.overrideRequestMapping && !mappings[key])) {
                          _context5.next = 9;
                          break;
                        }
                        console.error('Middleware: Mapping does not exist. Cannot proceed with API call.');
                        reject(new Error('no mapping exists'));
                        return _context5.abrupt('return');
                      case 9:
                        if (!(cacheLifespanInMinutes > 0)) {
                          _context5.next = 17;
                          break;
                        }
                        cacheKey = key + url.toLowerCase();
                        _context5.next = 13;
                        return driscollsReactUtilities.DuCache.Get(cacheKey, cacheLifespanInMinutes * 60000, false);
                      case 13:
                        data = _context5.sent;
                        if (!data) {
                          _context5.next = 17;
                          break;
                        }
                        resolve(data);
                        return _context5.abrupt('return');
                      case 17:
                        if (!isDefaultPayloadLoaded) {
                          newPayload = defaultPayloadHandler(token);
                          if (newPayload !== null) {
                            if (method.toUpperCase() === 'GET') {
                              defaultPayload = null;
                            } else {
                              defaultPayload = newPayload;
                            }
                            isDefaultPayloadSet = true;
                          }
                          isDefaultPayloadLoaded = true;
                        }
                        request = combinedProps.overrideRequestMapping ? requestObj : processToExternal(key, requestObj || {});
                        convertedArgs = combinedProps.overrideRequestMapping ? args : convertArgsToExternal(key, args);
                        _context5.next = 22;
                        return ApiUtilities.HandleAPICall(name.toLowerCase(), overrideToken && overrideToken.length > 0 ? overrideToken : token, url, method, request, combinedProps, mappings[key], convertedArgs, isDefaultPayloadSet ? defaultPayload : null, headerObj).then(function () {
                          var _ref5 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(data) {
                            return regeneratorRuntime.wrap(function _callee4$(_context4) {
                              while (1) {
                                switch (_context4.prev = _context4.next) {
                                  case 0:
                                    return _context4.abrupt('return', new Promise(function () {
                                      var _ref6 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(resolve, reject) {
                                        var isFakeData, processedData, sortColumnName, arrayColumnName, map;
                                        return regeneratorRuntime.wrap(function _callee3$(_context3) {
                                          while (1) {
                                            switch (_context3.prev = _context3.next) {
                                              case 0:
                                                isFakeData = ApiUtilities.CheckRegisteredFunctions(name.toLowerCase());
                                                processedData = combinedProps.overrideResponseMapping ? isFakeData ? data : data.data : processToLocal(key, isFakeData ? data : data.data, combinedProps.allowEmptyValues);
                                                if (method === 'GET' && sortableMappingKeys[key]) {
                                                  sortColumnName = '';
                                                  arrayColumnName = '';
                                                  map = mappings[key];
                                                  map.forEach(function (m) {
                                                    if (m.IsArray) {
                                                      arrayColumnName = m.LocalVariableName;
                                                    }
                                                    if (m.IsSorting) {
                                                      sortColumnName = m.LocalVariableName;
                                                    }
                                                  });
                                                  if (arrayColumnName.length > 0 && sortColumnName.length > 0 && processedData[arrayColumnName] !== undefined) {
                                                    processedData[arrayColumnName] = processedData[arrayColumnName].sort(function (a, b) {
                                                      if (typeof a[sortColumnName] === 'number') {
                                                        return a[sortColumnName] - b[sortColumnName];
                                                      }
                                                      var aHasText = typeof a[sortColumnName] === 'string' && a[sortColumnName].length > 0;
                                                      var bHasText = typeof b[sortColumnName] === 'string' && b[sortColumnName].length > 0;
                                                      if (!aHasText) {
                                                        return bHasText ? 1 : 0;
                                                      } else if (!bHasText) {
                                                        return aHasText ? -1 : 0;
                                                      }
                                                      return a[sortColumnName].localeCompare(b[sortColumnName]);
                                                    });
                                                  }
                                                }
                                                if (!(cacheKey.length > 0)) {
                                                  _context3.next = 6;
                                                  break;
                                                }
                                                _context3.next = 6;
                                                return driscollsReactUtilities.DuCache.Save(cacheKey, processedData, false);
                                              case 6:
                                                resolve(processedData);
                                              case 7:
                                              case 'end':
                                                return _context3.stop();
                                            }
                                          }
                                        }, _callee3, this);
                                      }));
                                      return function (_x25, _x26) {
                                        return _ref6.apply(this, arguments);
                                      };
                                    }()));
                                  case 1:
                                  case 'end':
                                    return _context4.stop();
                                }
                              }
                            }, _callee4, _this);
                          }));
                          return function (_x24) {
                            return _ref5.apply(this, arguments);
                          };
                        }()).catch(function (error) {
                          reject(error);
                        });
                      case 22:
                        result = _context5.sent;
                        resolve(result);
                      case 24:
                      case 'end':
                        return _context5.stop();
                    }
                  }
                }, _callee5, this);
              }));
              return function (_x22, _x23) {
                return _ref4.apply(this, arguments);
              };
            }()));
          case 1:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, this);
  }));
  return function sendApiCall(_x13, _x14, _x15, _x16, _x17, _x18, _x19) {
    return _ref3.apply(this, arguments);
  };
}();
var createSendCall = function createSendCall(name, token, url, method, requestObj, props, args, cacheLifespanInMinutes, headerObj) {
  return {
    name: name,
    token: token,
    url: url,
    method: method,
    requestObj: requestObj,
    props: props,
    args: args,
    cacheLifespanInMinutes: cacheLifespanInMinutes,
    headerObj: headerObj
  };
};
var attachReturnFunction = function attachReturnFunction(sendCall, weight, returnFunction, errorFunction) {
  if (!returnFunction || typeof returnFunction !== 'function') {
    console.error('Cannot attach to Send call, no function provided!');
    return sendCall;
  }
  sendCall.weight = weight || 200;
  sendCall.returnFunction = returnFunction;
  sendCall.errorFunction = errorFunction || function (error) {
    console.error(error);
    throw error;
  };
  return sendCall;
};
var sleep = function sleep(msec) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, msec);
  });
};
var sendCallWithReturns = function () {
  var _ref7 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(name, callToMake, statusUpdateFunction) {
    return regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return Middleware.Send(callToMake.name, callToMake.token, callToMake.url, callToMake.method, callToMake.requestObj, _extends({}, InitialProps, callToMake.props),
            //By default we don't want a loading screen for multiple calls, but we allow this to be overridden
            callToMake.args, callToMake.cacheLifespanInMinutes, callToMake.headerObj).then(function (data) {
              sendMultipleStatus[name].successCount++;
              statusUpdateFunction(sendMultipleStatus[name].errorCount > 0 ? 'Having Problems Loading Data' : 'Loading Data From Server', sendMultipleStatus[name].successCount, sendMultipleStatus[name].errorCount, sendMultipleStatus[name].total);
              try {
                callToMake.returnFunction(data);
              } catch (error) {
                console.error('API Return Function Error: ' + callToMake.name + ' ' + callToMake.url);
              }
            }).catch(function (error) {
              sendMultipleStatus[name].errorCount++;
              statusUpdateFunction('Having Problems Loading Data', sendMultipleStatus[name].successCount, sendMultipleStatus[name].errorCount, sendMultipleStatus[name].total);
              try {
                callToMake.errorFunction(error);
              } catch (error) {
                console.error('API Return Function Error: ' + callToMake.name + ' ' + callToMake.url);
              }
            });
          case 2:
          case 'end':
            return _context7.stop();
        }
      }
    }, _callee7, this);
  }));
  return function sendCallWithReturns(_x27, _x28, _x29) {
    return _ref7.apply(this, arguments);
  };
}();
var sendMultipleStatus = [];
var sendMultiple = function () {
  var _ref8 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(name, sendCalls, statusUpdateFunction) {
    return regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            return _context9.abrupt('return', new Promise(function () {
              var _ref9 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(resolve, reject) {
                var callsSortedLargestToSmallest, callsSorted, count, arrIndex, i, j, currentIndexRunning, callToMake;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                  while (1) {
                    switch (_context8.prev = _context8.next) {
                      case 0:
                        //TODO: If the status object below is set already we should cancel all pending API calls, otherwise bad things happen. This is an edge case.

                        sendMultipleStatus[name] = {
                          successCount: 0,
                          errorCount: 0,
                          total: sendCalls.length
                        };

                        //Sort largest to smallest
                        callsSortedLargestToSmallest = sendCalls.sort(function (callA, callB) {
                          return callB.weight - callA.weight;
                        });
                        callsSorted = [];
                        count = sendMultipleStatus[name].total;
                        arrIndex = 0;

                        //Sort Largest, then smallest, then second largest, etc (this is to balance the loading progress bar in the ui)

                        for (i = 0, j = count - 1; i <= count / 2 || j > count / 2; i++, j--) {
                          if (arrIndex < count) {
                            callsSorted[arrIndex] = callsSortedLargestToSmallest[i];
                            arrIndex++;
                          }
                          if (arrIndex < count) {
                            callsSorted[arrIndex] = callsSortedLargestToSmallest[j];
                            arrIndex++;
                          }
                        }

                        //While apis are not called yet keep calling more
                        statusUpdateFunction('Loading Data From Server', 0, 0, count);
                        currentIndexRunning = 0;
                      case 8:
                        if (!(sendMultipleStatus[name].successCount + sendMultipleStatus[name].errorCount < count)) {
                          _context8.next = 14;
                          break;
                        }

                        //See what we can run
                        if (currentIndexRunning - (sendMultipleStatus[name].successCount + sendMultipleStatus[name].errorCount) < 5 && currentIndexRunning < count) {
                          //lets run the next one
                          callToMake = callsSorted[currentIndexRunning];
                          currentIndexRunning++;
                          sendCallWithReturns(name, callToMake, statusUpdateFunction);
                        }
                        _context8.next = 12;
                        return Middleware.Sleep(50);
                      case 12:
                        _context8.next = 8;
                        break;
                      case 14:
                        statusUpdateFunction(sendMultipleStatus[name].errorCount > 0 ? 'We Had Problems Loading Data' : 'Data Loaded Successful', sendMultipleStatus[name].successCount, sendMultipleStatus[name].errorCount, sendMultipleStatus[name].total);
                        if (sendMultipleStatus[name].successCount === count) {
                          resolve('All good in the hood!');
                        } else {
                          reject(sendMultipleStatus[name].errorCount + ' out of ' + count + ' apis failed');
                        }
                      case 16:
                      case 'end':
                        return _context8.stop();
                    }
                  }
                }, _callee8, this);
              }));
              return function (_x33, _x34) {
                return _ref9.apply(this, arguments);
              };
            }()));
          case 1:
          case 'end':
            return _context9.stop();
        }
      }
    }, _callee9, this);
  }));
  return function sendMultiple(_x30, _x31, _x32) {
    return _ref8.apply(this, arguments);
  };
}();
var registerOverrideToken = function registerOverrideToken(token) {
  overrideToken = token || '';
};
var registerDefaultPayloadHandler = function registerDefaultPayloadHandler(defaultPayloadFunction) {
  defaultPayloadHandler = defaultPayloadFunction;
};
var Middleware = {
  CheckMappingExists: checkMiddlewareMapping,
  CreateMapping: createMiddlewareMapping,
  CreateIndexMapping: createMiddlewareIndexMapping,
  CreateSortMapping: createMiddlewareSortMapping,
  CreateArrayMapping: createMiddlewareArrayMapping,
  CreateArrayResultCountMapping: createMiddlewareArrayResultCountMapping,
  CreateObjectMapping: createMiddlewareObjectMapping,
  RegisterMapping: registerMiddlewareMapping,
  SetProps: setPropsObj,
  EmptyProps: InitialProps,
  Send: sendApiCall,
  SendRaw: sendRawApiCall,
  SendRawNoDialogs: sendRawApiCallNoDialogs,
  SendMultiple: sendMultiple,
  CreateSendCall: createSendCall,
  AttachReturnFunction: attachReturnFunction,
  RegisterFakeDataHandler: ApiUtilities.RegisterFunctions,
  CreateHandler: ApiUtilities.CreateHandler,
  CheckRegisteredFakeDataHandlers: ApiUtilities.CheckRegisteredFunctions,
  Filter: ApiUtilities.Filter,
  FilterToOne: ApiUtilities.FilterToOne,
  NoOp: ApiUtilities.NoOp,
  UpdateOne: ApiUtilities.UpdateOne,
  Mappings: mappings,
  Sleep: sleep,
  RegisterOverrideToken: registerOverrideToken,
  RegisterDefaultPayloadHandler: registerDefaultPayloadHandler
};
var _this2 = undefined;
var emptyFunc = function emptyFunc() {
  return {};
};
var defaultUrlFunc = function defaultUrlFunc(url, currentPage, pageSize) {
  var currentPageParameter = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'startPage';
  var pageSizeParameter = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'pageSize';
  return '' + url + (url.includes('?') ? '&' : '?') + currentPageParameter + '=' + currentPage + '&' + pageSizeParameter + '=' + pageSize;
};
var setStatusFunc = function setStatusFunc(pagesLoaded, pageSize) {
  var totalResults = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var totalPages = 0;
  if (totalResults > 0) {
    totalPages = Math.ceil(totalResults / pageSize);
  }
  var percentValue = 0;
  var percentText = '0%';
  if (totalPages > 0) {
    percentValue = pagesLoaded / totalPages;
    percentText = (percentValue * 100).toFixed(2) + '%';
  }
  return {
    pagesLoaded: pagesLoaded,
    pageSize: pageSize,
    totalResults: totalResults,
    totalPages: totalPages,
    percentValue: percentValue,
    percentText: percentText
  };
};

//Requires Data to come back in Results
var getAllData = function () {
  var _ref = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(middlewareName, token, url, statusFunc) {
    var resultParameter = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'Results';
    var totalResultsParameter = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'total';
    var currentPageQueryParameter = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 'startPage';
    var pageSizeQueryParameter = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 'pageSize';
    var firstPageNumber = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : 1;
    var pageSize = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : 100;
    var urlFunc = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : defaultUrlFunc;
    var method = arguments.length > 11 && arguments[11] !== undefined ? arguments[11] : 'GET';
    var requestObjFunc = arguments.length > 12 && arguments[12] !== undefined ? arguments[12] : emptyFunc;
    var props = arguments.length > 13 && arguments[13] !== undefined ? arguments[13] : {};
    var args = arguments.length > 14 && arguments[14] !== undefined ? arguments[14] : {};
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt('return', new Promise(function () {
              var _ref2 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(resolve, reject) {
                var _this = this;
                var allData, totalResults;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        statusFunc(setStatusFunc(0, pageSize));
                        allData = [];
                        totalResults = 0;

                        //Need to call the api to get the first page to see how many results there are

                        Middleware.Send(middlewareName, token, urlFunc(url, firstPageNumber, pageSize, currentPageQueryParameter, pageSizeQueryParameter), method, requestObjFunc(firstPageNumber, pageSize), props, args).then(function () {
                          var _ref3 = asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data) {
                            var tempTotalResults, totalPages, i, pageData;
                            return regeneratorRuntime.wrap(function _callee$(_context) {
                              while (1) {
                                switch (_context.prev = _context.next) {
                                  case 0:
                                    tempTotalResults = Number(data[totalResultsParameter]);
                                    if (!(Array.isArray(data[resultParameter]) && Number.isInteger(tempTotalResults))) {
                                      _context.next = 21;
                                      break;
                                    }
                                    allData = allData.concat(data[resultParameter]);
                                    totalResults = tempTotalResults;
                                    statusFunc(1, pageSize, totalResults);
                                    if (!(totalResults < pageSize)) {
                                      _context.next = 8;
                                      break;
                                    }
                                    resolve(allData);
                                    return _context.abrupt('return');
                                  case 8:
                                    totalPages = Math.ceil(totalResults / pageSize);
                                    i = 1;
                                  case 10:
                                    if (!(i < totalPages)) {
                                      _context.next = 18;
                                      break;
                                    }
                                    _context.next = 13;
                                    return Middleware.Send(middlewareName, token, urlFunc(url, firstPageNumber + i, pageSize, currentPageQueryParameter, pageSizeQueryParameter), method, requestObjFunc(firstPageNumber + i, pageSize), props, args);
                                  case 13:
                                    pageData = _context.sent;
                                    if (Array.isArray(pageData[resultParameter])) {
                                      allData = allData.concat(pageData[resultParameter]);
                                      statusFunc(i + 1, pageSize, totalResults);
                                    } else {
                                      reject('Failure to retrieve page ' + (i + 1) + ', cannot continue download');
                                    }
                                  case 15:
                                    i++;
                                    _context.next = 10;
                                    break;
                                  case 18:
                                    resolve(allData);
                                    _context.next = 22;
                                    break;
                                  case 21:
                                    reject('Did not find ' + resultParameter + ' in the returned result');
                                  case 22:
                                  case 'end':
                                    return _context.stop();
                                }
                              }
                            }, _callee, _this);
                          }));
                          return function (_x21) {
                            return _ref3.apply(this, arguments);
                          };
                        }()).catch(function (error) {
                          reject('Something bad happened trying to get the first chunk of the file. Error: ' + error);
                        });
                      //If there is a failure show its bad.
                      // If there is no more pages return success
                      //If there are more create a send multiple array

                      case 4:
                      case 'end':
                        return _context2.stop();
                    }
                  }
                }, _callee2, this);
              }));
              return function (_x19, _x20) {
                return _ref2.apply(this, arguments);
              };
            }()));
          case 1:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this2);
  }));
  return function getAllData(_x4, _x5, _x6, _x7) {
    return _ref.apply(this, arguments);
  };
}();
var DownloadUtilities = {
  GetAllData: getAllData
};

//External Libraries
window.One_Ring_Version = '1.8.0';
window.Versions = window.Versions || [];
if (window.Versions.findIndex(function (v) {
  return v.package === 'one-ring';
}) < 0) {
  window.Versions.push({
    package: 'one-ring',
    name: 'One Ring',
    description: 'API Management',
    version: window.One_Ring_Version
  });
}
exports.ApiUtilities = ApiUtilities;
exports.Middleware = Middleware;
exports.DownloadUtilities = DownloadUtilities;
//# sourceMappingURL=index.js.map
